"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var stepperThemefication = function stepperThemefication(color, progressColor) {
  var hexa = _tokens.colors[color.color + color.scale];
  var hexaProgress = _tokens.colors[progressColor.color + progressColor.scale];
  var theme = {
    stepper: "\n      background-color: ".concat(hexa, ";\n    "),
    progressStepper: "\n      background-color: ".concat(hexaProgress, "\n    ")
  };
  return theme;
};

var _default = stepperThemefication;
exports.default = _default;